<template lang="pug">
div
  v-container
    div.text-lg.font-medium.basic700--text {{ $t('qr_code') }}
    div.text-sm.font-normal.basic600--text {{ $t('qr_code_desc', { item: 'campaign page' }) }}

  div.mt-3.d-flex.align-center
    vue-qrcode.ml-n1(id="campaignLink" :value="getQRLinkURL()" :options="{ width: 144 }")
    div.ml-6(style="width: 200px")
      v-btn.round-lg.text-md.font-bold.text-none.pl-5.pr-4.py-3(color="basic700" outlined depressed height="48" @click="downloadPdf")
        v-icon(left color="basic700") mdi-file-pdf-box
        | {{ $t('download_as_pdf') }}
      v-btn.round-lg.text-md.font-bold.text-none.pl-5.pr-4.py-3.mt-4(color="basic700" outlined depressed height="48" @click="downloadPng")
        v-icon.mb-1(left color="basic700") $yzi-download-01
        | {{ $t('download_as_png') }}
  
</template>

<script>
import { mapGetters } from 'vuex'
import VueQrcode from '@chenfengyuan/vue-qrcode'

export default {
  name: 'SharingQrCode',
  components: { VueQrcode },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
  },
  data () {
    return {
      embedSelection: null,
      htmlContent: null,
      rules: {
        not_empty: [v => v.trim().length || 'This field is required'],
        not_empty_array: [v => !!(v && v.length) || 'This field is required']
      },
    }
  },
  methods: {
    getQRLinkURL () {
      return `https://${this.company.slug}.yezza.co/appointment`
    },
    downloadPng () {
      var canvas = document.getElementById("campaignLink")
      var dataURL = canvas.toDataURL("image/png")
      const linkSource = dataURL
      const downloadLink = document.createElement('a')
      document.body.appendChild(downloadLink)
      downloadLink.href = linkSource
      downloadLink.target = '_self'
      downloadLink.download = 'QrCode'
      downloadLink.click()
    },
    downloadPdf () {
      let qrUrl = encodeURI(`https://${process.env.VUE_APP_BASE_DOMAIN}/pdf-qr?link=${this.getQRLinkURL()}`)
      let downloadUrl = `https://pdf.yezza.io/?url=${qrUrl}&type=pdf&filename=qrcode.pdf&waitUntil=networkidle0&printBackground=true&width=305&height=305`
      window.open(downloadUrl)
    }
  },
}
</script>

<style scoped>

</style>